import { useState } from 'react'
import { Modal, ModalContent } from '@/components/modal/Modal'
import { Button } from '@/components/button/Button'
import type { TableEdit } from '../schemas'

export default function EditTableNameDialog({
  name,
  saving,
  error,
  onSave,
  onClose,
}: {
  name: string
  saving: boolean
  error: string | null
  onSave: (edit: TableEdit) => Promise<boolean>
  onClose: () => void
}) {
  const [draft, setDraft] = useState(name)
  return (
    <Modal
      open
      onOpenChange={(open) => {
        if (!open && !saving) onClose()
      }}
    >
      <ModalContent title="Edit table name" width="md" height="max-md">
        <form
          className="flex flex-col gap-4 p-4"
          onSubmit={async (event) => {
            event.preventDefault()
            if (await onSave({ action: 'rename-table', name: draft.trim() })) onClose()
          }}
        >
          <label className="text-sm">
            Table name
            <input
              autoFocus
              value={draft}
              onChange={(event) => setDraft(event.target.value)}
              disabled={saving}
              className="mt-1 block w-full rounded border border-brand-neutral-300 p-2"
            />
          </label>
          {error && (
            <p role="alert" className="text-sm text-red-800">
              {error}
            </p>
          )}
          <div className="flex justify-end gap-2">
            <Button type="button" variant="plain" disabled={saving} onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={saving || !draft.trim()}>
              Save
            </Button>
          </div>
        </form>
      </ModalContent>
    </Modal>
  )
}
